import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

function Notifications() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
 

  useEffect(() => {
    retrieveNotififcation();
  }, []);

  const retrieveNotififcation = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setTransaction(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short" }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <>
      <div className="content noti-web ">
        <Row>
          <Col md="5">
            <Card className="outer-line noti-card">
            <CardTitle tag="h5">Notifications</CardTitle>
              <CardBody className="jag-tran-card" style={{color: "white"}}>
                {transaction.map((transaction) => (
                  <div key={transaction.id} className="jag-transaction-item">
                    <div className="jag-transaction-info">
                      <div>
                        <div
                          className="jag-transaction-type"
                          style={{ textTransform: "uppercase" }}
                        >
                          {transaction.title}
                        </div>

                        <div className="jag-transaction-type noti-mess">
                          {transaction.message}
                        </div>
                      </div>
                    </div>
                    <div className="jag-transaction-details">
                      <div
                        className="jag-transaction-time"
                        style={{ paddingLeft: "1px" }}
                      >
                        {formatDate(transaction.createdAt)}
                      </div>
                    </div>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="jag-transaction-list tran-mob bcksp">
        <CardHeader>
          <CardTitle tag="h4"> All Notifications</CardTitle>
        </CardHeader>
        <CardBody className="jag-tran-card">
          {transaction.map((transaction) => (
            <div key={transaction.id} className="jag-transaction-item">
              <div className="jag-transaction-info">
                <div>
                  <div
                    className="jag-transaction-type"
                    style={{ textTransform: "uppercase" }}
                  >
                    {transaction.title}
                  </div>

                  <div className="jag-transaction-type noti-mess">
                    {transaction.message}
                  </div>
                </div>
              </div>
              <div className="jag-transaction-details">
                <div
                  className="jag-transaction-time"
                  style={{ paddingLeft: "1px" }}
                >
                  {formatDate(transaction.createdAt)}
                </div>
              </div>
            </div>
          ))}
        </CardBody>
      </div>
      <div className="content bcksp1">
        <Row>
          <Col md="8">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Help and Support</CardTitle>

                <Row>
                  <Col className="noflex">
                    <div className="box-11">
                      <div className="help-1">
                        <div className="help-icon c-1">
                          <i class="fa-solid fa-phone"></i>
                        </div>
                        <div className="help-text">
                          <p className="p-text">Reach out to Us </p>
                          <a href="tel:+14047291859">
                            <p className="p-number c-1">+1 (404) 729-1859</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col className="noflex">
                    <div className="box-11">
                      <div className="help-1">
                        <div className="help-icon c-2">
                          <i class="fa-regular fa-envelope"></i>
                        </div>
                        <div className="help-text">
                          <p className="p-text">Send Us an Email</p>
                          <a href="mailto:Americanmassagecouncil@gmail.com">
                            <p className="p-number c-2">
                              Americanmassagecouncil
                            </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody></CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Notifications;
